<template>
    <main class="main-content main-content-bg mt-0">
        <div class="page-header min-vh-100" style="
        background-image: url('/brasal/bg-espaco-cliente.jpg');
      ">
            <span class="mask bg-gradient-dark opacity-6"></span>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-7 mt-2">
                        <div class="card border-0 mb-0">
                            <div class="card-header bg-transparent d-flex justify-content-center align-items-center">
                                <img :src="logo" :class="segment" alt="Logo Brasal" />
                            </div>

                            <div class="card-body px-lg-5 pt-0 align-items-center text-center">
                                <div class="mt-1 mb-4">
                                    <div class="">
                                        <span style="font-size: 15px;"
                                            class="segment-primary-color font-weight-bolder">Bem vindo ao Espaço
                                            Cliente da Brasal Incorporações.</span>
                                    </div>
                                    <div style="font-size: 10px;" class="mt-4">
                                        Em caso de dúvida, entre em contato com a Central de relacionamento com o
                                        Cliente.
                                    </div>
                                </div>
                                <form role="form" class="text-start" @submit.prevent="formValidation">

                                    <div class="mb-3">
                                        <argon-input id="username" v-model="form.username" type="text"
                                            placeholder="Usuário" aria-label="Usuário"
                                            :error="validate.username.$error" />
                                    </div>
                                    <div class="mb-3">
                                        <argon-input id="password" v-model="form.password" type="password"
                                            placeholder="Senha" aria-label="Password"
                                            :error="validate.password.$error" />
                                    </div>
                                    <!-- <argon-switch id="rememberMe" name="rememberMe">
                                        Lembre-se de mim
                                    </argon-switch> -->

                                    <div class="text-center">
                                        <argon-button color="primary" full-width class="my-4 mb-2"
                                            :disabled="loading">Entrar <i v-if="loading"
                                                class="fa fa-spinner fa-pulse fa-fw"></i></argon-button>
                                    </div>
                                    <div class="mb-2 position-relative text-center">
                                        <p
                                            class="text-sm mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
                                            ou
                                        </p>
                                    </div>
                                </form>
                                <div class="text-center">
                                    <router-link :to="{ name: 'Recuperar Senha' }" class="white font-weight-bold">
                                        <argon-button color="dark" full-width class="mt-2 mb-4 hover-color" style="background-color: #212329;">
                                            Esqueci minha senha
                                        </argon-button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

</template>
<script setup>
import { onBeforeMount, onBeforeUnmount, ref, reactive } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showToast } from "@/assets/js/toast.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import logo from "@/assets/img/logos/brasal/brasal_incorporacoes.png";
import axios from "axios";
import { setAuthorization } from "../../../../helpers/general";
import { useRouter } from 'vue-router'

const store = useStore();
const router = useRouter()
const segment = process.env.SEGMENT;
const loading = ref(false);
const form = reactive({
    username: ref(''),
    password: ref(''),
});
console.log(process.env.NODE_ENV)
const rules = {
    username: { required },
    password: { required },
};

const validate = useVuelidate(rules, form);

const toggleDefaultLayout = () => {
    store.commit("toggleDefaultLayout");
};

const formValidation = () => {
    validate.value.$touch();
    if (validate.value.$invalid) {
        showToast('Campos obrigatórios não preenchidos.', 'error');
        return;
    }
    login()
};
// @TODO
const login = async () => {
    clearStorage()
    loading.value = true;
    try {
        const response = await axios.post('/auth/login-ws', form);
        if (response.data) {
            setAuthorization(response.data.access_token)
            store.commit('loginSuccess', response.data)
            router.push({ name: 'Minhas Unidades' })
        }
    } catch (error) {
        if (error.response) {
            console.log(error.response)
            showToast(error.response.data.error, 'error')
        } else {
            console.error('Erro de resposta desconhecido:', error)
            showToast('Erro desconhecido ao processar a resposta', 'error')
        }
    } finally {
        loading.value = false;
    }
};

const clearStorage = () => {
    localStorage.removeItem("allContracts");
    localStorage.removeItem("currentContract");
}

onBeforeMount(() => {
    store.state.hideConfigButton = true;
    toggleDefaultLayout();
});

onBeforeUnmount(() => {
    store.state.hideConfigButton = false;
    toggleDefaultLayout();
});
</script>

<style scoped>
.hover-color:hover {
    color: #9d91a5 !important;
}
</style>